<template>
  <div class="app-card-event" :style="styleColor">
    <div class="app-card-event__inner">
      <div class="app-card-event__date-time">
        <div class="app-card-event__time">
          <span v-if="data.time_start">{{ data.time_start }}</span>
          - <span v-if="data.time_end">{{ data.time_end }}</span></div>
        <div class="app-card-event__date" v-if="data.date">{{ data.date }}</div>
      </div>
      <div class="app-card-event__main">
        <div class="app-card-event__track" v-if="treksList">
          <p class="app-card-event__track-item" v-for="(item, idx) in treksList"
              :key="`item${idx}`" :style="item.trek_color ? `--color: ${item.trek_color}` : null">
            {{item.name}}
          </p>
        </div>
        <div class="app-card-event__track" v-else-if="data.trek">{{ data.trek }}</div>
        <div class="app-card-event__title" v-if="data.title" @click="$emit('event-open', data.id)">
          {{ data.title }}
        </div>
        <div class="app-card-event__location" v-if="data.hall">{{ data.hall }}</div>
      </div>
      <div class="app-card-event__slider" v-if="data.partners.length > 0">
        <div ref="swiper" class="swiper">
          <!-- Additional required wrapper -->
          <div class="swiper-wrapper">
            <!-- Slides -->
            <div class="swiper-slide"
                 v-for="partner in data.partners" :key="partner.id">
              <AppCardPartner :data="partner"/>
            </div>
          </div>
        </div>
        <div class="swiper-pagination" :class="`swiper-pagination${data.id}`"></div>
      </div>
    </div>
    <div class="app-card-event__favorites" :class="data.favorites ? 'is-active' : ''"
         @click="$emit('favorites', data.id)">
      <span v-if="!data.favorites">{{ data.outFavorites }}</span>
      <span v-if="data.favorites">{{ data.inFavorites }}</span>
    </div>
  </div>
</template>

<script>
// Import Swiper Vue.js components

import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import AppCardPartner from '@/components/app-card-partner/app-card-partner.vue';

export default {
  components: {
    AppCardPartner,
  },
  props: ['data'],
  name: 'AppCardEvent',
  data() {
    return {
      activeIndex: 0,
      slider: null,
    };
  },
  methods: {
    sliderUpdate() {
      this.slider.update();
    },
  },
  computed: {
    treksList() {
      if (this.data?.treks) {
        return Array.from(Object.values(this.data.treks)).filter((item) => item !== null);
      }
      return null;
    },
    styleColor() {
      let treksLength = 0;

      // если треки из справочника
      if (this.data?.treks) {
        // eslint-disable-next-line max-len
        const treksList = Array.from(Object.values(this.data.treks)).filter((item) => item !== null);
        treksLength = treksList.length > 0 ? treksList.length : 0;
        if (treksLength > 1) {
          return '--color: #d3d4d6';
        }
        return `--color: ${treksList[0].trek_color}`;
      }
      // если трек один
      const trekColor = this.data?.trek_color;
      if (trekColor && treksLength < 2) {
        return `--color: ${trekColor}`;
      }
      return null;
    },
  },
  mounted() {
    if (this.data.partners.length > 0) {
      const SECOND = 1000; // milliseconds

      // eslint-disable-next-line no-new
      this.slider = new Swiper(this.$refs.swiper, {

        modules: [Navigation, Pagination, Autoplay],

        loop: true,
        autoplay: {
          delay: 3 * SECOND,
          disableOnInteraction: false,
        },
        speed: 2 * SECOND,
        pagination: {
          el: `.swiper-pagination${this.data.id}`,
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        on: {
          slideChange: (swiper) => {
            this.activeIndex = swiper.realIndex;
          },
        },
      });

      this.slider.update();
    }
  },
};
</script>

<style lang="scss">
@import "app-card-event";
</style>
